import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles({
  spinner: {
    position: 'absolute',
    top: 'calc(50% - 20px)',
    left: 'calc(50% - 20px)',
  },
})
